<template>
  <el-dialog v-model="localShowModal" width="95%" :before-close="closeModal" destroy-on-close center top="30vh"
    :close-on-click-modal="false" :close-on-press-escape="false" :visible.sync="localShowModal" class="login-dialog">
    <!-- 用户登录 -->
    <el-tabs key="login-tabs" v-model="activeName" class="login-tabs" @tab-click="handleClickTab"
      v-if="!forgetPasswordVisible && !initPasswordVisible">
      <!-- 账号密码登录 -->
      <el-tab-pane label="密码登录" name="account" class="login-container">
        <div class="login-content">
          <el-form ref="loginRef" :model="loginForm" :rules="rules" style="width: 300px;">
            <el-form-item prop="phoneNumber">
              <el-input v-model="loginForm.phoneNumber" placeholder="请输入手机号码" :prefix-icon="Iphone" />
            </el-form-item>
            <el-form-item prop="password" class="password-item">
              <el-input v-model="loginForm.password" placeholder="密码" class="password" :prefix-icon="Lock"
                show-password />
            </el-form-item>
            <el-form-item class="update-password-container">
              <div class="update-password-content">
                <el-button class="update-password" type="primary" link @click="handleClickRegister">注册</el-button>
                <el-button class="update-password" type="primary" link @click="forgetPassword($event)">忘记密码</el-button>
              </div>
            </el-form-item>
            <el-form-item v-if="loginTips?.msg">
              <el-alert :title="loginTips?.msg" :type="loginTips?.type" show-icon :closable="false" />
            </el-form-item>
            <el-form-item class="contract-text">
              <el-checkbox v-model="contractValue" class="checkbtn" />
              我已阅读并同意<span class="contract" @click="scanContract(1)">用户协议</span>、<span class="contract"
                @click="scanContract(2)">隐私政策</span>和<span class="contract" @click="scanContract(3)">付费协议</span>
            </el-form-item>
            <el-form-item>
              <el-button class="login-btn" type="primary" @click="handleClickLoginButton($event, openTips)"
                :loading="loginLoading">登录</el-button>
            </el-form-item>
          </el-form>
        </div>
      </el-tab-pane>

      <!-- 验证码登录 -->
      <el-tab-pane label="验证码登录" name="phone" class="login-container">
        <!-- 新增提示行 -->
        <div style="text-align:center;margin-bottom:8px;font-size:14px;">
          <span style="color:red;"></span>如收不到验证码，请使用
          <span style="color:red;cursor:pointer;text-decoration:underline;" @click="activeName = 'oneClick'">一键登录</span>
        </div>
        <div class="login-content">
          <el-form ref="loginRef" :model="loginForm" :rules="rules" style="width: 300px;">
            <el-form-item prop="phoneNumber">
              <el-input v-model="loginForm.phoneNumber" placeholder="请输入手机号码" :prefix-icon="Iphone" />
            </el-form-item>
            <el-form-item prop="phoneCodeValue" class="verification-item">
              <el-input v-model="loginForm.phoneCodeValue" placeholder="请输入验证码" class="verification-code"
                :prefix-icon="Lock" />
              <el-button @click="sendVerificationCode" class="verification-code-btn" :disabled="isCountingDown">
                {{ isCountingDown ? `${countDown}秒后重新获取` : '获取验证码' }}
              </el-button>
            </el-form-item>
            <!-- 验证码提示信息 -->
            <el-form-item v-if="isCountingDown" class="verification-tips">
              <div class="verification-tips-text">
                请及时设置密码！ 如您未收到验证码，请多次发送或者联系微信yinghuohaihai或切换一键登录
              </div>
            </el-form-item>
            <el-form-item v-if="loginTips?.msg">
              <el-alert :title="loginTips?.msg" :type="loginTips?.type" show-icon :closable="false" />
            </el-form-item>
            <div class="inviteUser" v-if="inviteCode">
              <div class="desc">新用户会自动注册</div>
              <span class="invite">邀请人：{{ nickName }}，新用户注册后双方都将获得额外积分奖励（仅对首次登陆的用户有效）</span>
            </div>

            <!-- 邀请码输入框 -->
            <el-form-item prop="inviteCodeInput" class="invite-code-item">
              <el-input v-model="loginForm.inviteCodeInput" placeholder="邀请人(选填)" class="invite-code-input"
                :prefix-icon="User" clearable @input="handleInviteCodeInput" />
            </el-form-item>

            <el-form-item class="contract-text">
              <el-checkbox v-model="contractValue" class="checkbtn" />
              我已阅读并同意<span class="contract" @click="scanContract(1)">用户协议</span>、<span class="contract"
                @click="scanContract(2)">隐私政策</span>和<span class="contract" @click="scanContract(3)">付费协议</span>
            </el-form-item>
            <el-form-item>
              <el-button class="login-btn" type="primary" @click="handleClickLoginAndRegisterButton($event, openTips)"
                :loading="loginLoading">登录/注册</el-button>
            </el-form-item>
          </el-form>
        </div>
      </el-tab-pane>

      <!-- 一键登录 -->
      <el-tab-pane label="一键登录" name="oneClick" class="login-container">
        <template #label>
          <span @click="handleOneClickTabClick">一键登录</span>
        </template>
        <!-- 新增提示行 -->
        <div style="text-align:center;margin-bottom:8px;font-size:14px;">
          <span style="color:red;">微信里</span>暂时<span style="color:red;">只支持移动号码</span>一键登录，其他运营商请用验证码登录或在外部浏览器里一键登录
        </div>
        <div class="login-content">
          <!-- 如果是微信，则提示使用外部浏览器 -->
          <div v-if="isWeChat()" class="wechat-browser-tip">
            <el-form style="width: 300px;">
              <el-form-item>
                <div class="wechat-tip-content">

                  <p class="error-text">一键登录功能不支持微信浏览器</p>
                  <p class="suggestion-text">请使用其他浏览器或切换登录方式</p>
                  <div class="website-link">
                    <div class="link-header">
                      <p class="link-label">网站链接：</p>
                      <el-button class="copy-btn" size="small" type="primary" @click="copyWebsiteLink">复制链接</el-button>
                    </div>
                    <div class="link-container">
                      <span class="link-text">{{ getCurrentUrl() }}</span>
                    </div>
                  </div>
                </div>
              </el-form-item>
              <el-form-item>
                <el-button class="switch-login-btn" type="primary" @click="openInExternalBrowser">在外部浏览器打开</el-button>
              </el-form-item>
              <el-form-item>
                <div class="browser-tip">
                  <p class="tip-text">💡 点击右上角"⋯"菜单,选择"在浏览器中打开"</p>
                </div>
              </el-form-item>
            </el-form>
          </div>

          <!-- 网络不可用时显示提示 -->
          <div v-if="!isWeChat() && !isCellularNetwork" class="network-error-content">
            <el-form style="width: 300px;">
              <el-form-item>
                <div class="network-error-desc">
                  <p class="intro-text">一键登录无需验证码和密码</p>
                  <p class="error-text">请断开WiFi使用移动网络后重试</p>
                </div>
              </el-form-item>
              <el-form-item>
                <el-button class="retry-btn" type="primary" @click="handleClickLoginRetryNetwork"
                  :loading="retryLoading">重试</el-button>
              </el-form-item>
            </el-form>
          </div>

          <!-- 网络可用时显示一键登录页面 -->
          <el-form v-if="!isWeChat() && isCellularNetwork" ref="loginRef" :model="loginForm" :rules="rules"
            style="width: 300px;">
            <el-form-item>
              <div class="one-click-login-desc">
                <el-button class="one-click-login-main-btn" type="primary" @click="handleOneClickLogin"
                  :loading="oneClickLoginLoading">使用本机号码一键登录/注册</el-button>
                <p class="desc-text">无需输入密码或验证码，安全便捷</p>
              </div>
            </el-form-item>
            <el-form-item v-if="loginTips?.msg">
              <el-alert :title="loginTips?.msg" :type="loginTips?.type" show-icon :closable="false" />
            </el-form-item>

            <div class="inviteUser" v-if="inviteCode">
              <div class="desc">新用户会自动注册</div>
              <span class="invite">邀请人：{{ nickName }}，新用户注册后双方都将获得额外积分奖励（仅对首次登陆的用户有效）</span>
            </div>

            <!-- 邀请码输入框 -->
            <el-form-item prop="inviteCodeInput" class="invite-code-item">
              <el-input v-model="loginForm.inviteCodeInput" placeholder="邀请人(选填)" class="invite-code-input"
                :prefix-icon="User" clearable @input="handleInviteCodeInput" />
            </el-form-item>

            <el-form-item class="contract-text">
              <el-checkbox v-model="contractValue" class="checkbtn" />
              我已阅读并同意<span class="contract" @click="scanContract(1)">用户协议</span>、<span class="contract"
                @click="scanContract(2)">隐私政策</span>和<span class="contract" @click="scanContract(3)">付费协议</span>
            </el-form-item>
          </el-form>
        </div>
      </el-tab-pane>
    </el-tabs>

    <!-- 设置初始密码 -->
    <div class="init-content" v-if="initPasswordVisible">
      <h3 class="init-content-title">设置初始密码</h3>
      <el-form ref="initPasswordRef" :model="initPasswordForm" :rules="rules" style="width: 300px;">
        <el-form-item prop="phoneNumber">
          <el-input v-model="initPasswordForm.phoneNumber" placeholder="请输入手机号码" disabled :prefix-icon="Iphone" />
        </el-form-item>
        <el-form-item prop="password" class="update-password-item">
          <el-input v-model="initPasswordForm.password" placeholder="新密码" class="password" :prefix-icon="Lock"
            show-password />
        </el-form-item>
        <el-form-item prop="passwordConfirm" class="update-password-item">
          <el-input v-model="initPasswordForm.passwordConfirm" placeholder="确认密码" class="password" :prefix-icon="Lock"
            show-password />
        </el-form-item>

        <el-form-item v-if="initPasswordTips?.msg">
          <el-alert :title="initPasswordTips?.msg" :type="initPasswordTips?.type" show-icon :closable="false" />
        </el-form-item>

        <el-form-item class="update-password-btn-container">
          <el-button class="update-password-btn" type="primary" @click="handleInitPassword($event, openTips)"
            :loading="initPasswordLoading">注册</el-button>
        </el-form-item>
        <el-form-item class="update-password-btn-container">
          <el-button class="update-password-btn" @click="initPasswordVisible = false">返回</el-button>
        </el-form-item>
      </el-form>
    </div>

    <!-- 修改密码 -->
    <el-tabs key="update-password-tabs" v-model="activeUpdatePassword" class="update-password-tabs"
      @tab-click="handleUpdatePasswordClick" v-if="forgetPasswordVisible">
      <!-- 短信验证码修改 -->
      <el-tab-pane label="通过验证码修改" name="verifyCode" class="login-container">
        <!-- 新增提示行 -->
        <div style="text-align:center;margin-bottom:0px;margin-top:-10px;font-size:14px;">
          <span style="color:red;"></span>如收不到验证码，请使用<span style="color:red; cursor:pointer; text-decoration:underline;"
            @click="activeUpdatePassword = 'oneClickUpdate'">本机号码修改</span>
        </div>
        <div class="login-content">
          <el-form ref="updatePasswordRef" :model="updatePasswordForm" :rules="rules" style="width: 300px;">
            <el-form-item prop="phoneNumber">
              <el-input v-model="updatePasswordForm.phoneNumber" placeholder="请输入手机号码" :prefix-icon="Iphone" />
            </el-form-item>
            <el-form-item prop="phoneCodeValue" class="verification-item">
              <el-input v-model="updatePasswordForm.phoneCodeValue" placeholder="请输入验证码" class="verification-code"
                :prefix-icon="Lock" />
              <el-button @click="sendVerificationCode" class="verification-code-btn" :disabled="isCountingDown">
                {{ isCountingDown ? `${countDown}秒后重新获取` : '获取验证码' }}
              </el-button>
            </el-form-item>
            <!-- 验证码提示信息 -->
            <el-form-item v-if="isCountingDown" class="verification-tips">
              <div class="verification-tips-text">
                请及时设置密码！ 如您未收到验证码，请多次发送或者联系微信yinghuohaihai或切换一键登录
              </div>
            </el-form-item>
            <el-form-item prop="password" class="update-password-item">
              <el-input v-model="updatePasswordForm.password" placeholder="新密码" class="password" :prefix-icon="Lock"
                show-password />
            </el-form-item>

            <el-form-item v-if="updatePasswordTips?.msg">
              <el-alert :title="updatePasswordTips?.msg" :type="updatePasswordTips?.type" show-icon :closable="false" />
            </el-form-item>

            <el-form-item class="update-password-btn-container">
              <el-button class="update-password-btn" type="primary" @click="updatePassword($event, openTips)"
                :loading="updatePasswordLoading">修改密码</el-button>
            </el-form-item>
            <el-form-item class="update-password-btn-container">
              <el-button class="update-password-btn" @click="forgetPasswordVisible = false">返回</el-button>
            </el-form-item>
          </el-form>
        </div>
      </el-tab-pane>

      <!-- 原密码修改 -->
      <!-- 新增：通过本机号码修改tab，内容照抄一键登录tab -->
      <el-tab-pane label="通过本机号码修改" name="oneClickUpdate" class="login-container">
        <div style="text-align:center;margin-bottom:0px;margin-top:-10px;font-size:14px;">
          <span style="color:red;">微信里</span>暂时<span style="color:red;">只支持移动号码</span>修改，其他运营商请用验证码修改或在外部浏览器里使用本功能
        </div>
        <div class="login-content">
          <!-- 网络不可用时显示提示 -->
          <div v-if="!isCellularNetwork" class="network-error-content">
            <el-form style="width: 300px;">
              <el-form-item>
                <div class="network-error-desc">

                  <p class="error-text">请断开WiFi使用移动网络后重试</p>
                </div>
              </el-form-item>
              <el-form-item>
                <el-button class="retry-btn" type="primary" @click="handleClickChangePasswordRetryNetwork"
                  :loading="retryLoading">重试</el-button>
              </el-form-item>
            </el-form>
          </div>

          <!-- 网络可用时显示本机号码修改页面 -->
          <el-form v-if="isCellularNetwork" ref="oneClickUpdateRef" :model="oneClickUpdateForm" :rules="rules"
            style="width: 300px;">
            <el-form-item>
              <div class="one-click-login-desc">
                <!-- 新增密码输入框 -->
                <el-input v-model="oneClickUpdateForm.password" placeholder="新密码" class="password" :prefix-icon="Lock"
                  show-password style="margin-bottom: 12px;" type="password" />
                <el-input v-model="oneClickUpdateForm.passwordConfirm" placeholder="请确认新密码" class="password"
                  :prefix-icon="Lock" show-password style="margin-bottom: 12px;" type="password" />
                <div
                  v-if="oneClickUpdateForm.password && oneClickUpdateForm.passwordConfirm && oneClickUpdateForm.password !== oneClickUpdateForm.passwordConfirm"
                  style="color: #f56c6c; font-size: 13px; margin-bottom: 8px;">
                  两次输入的密码不一致
                </div>
                <el-button class="one-click-login-main-btn" type="primary" @click="handleOneClickChangePassword"
                  :loading="oneClickLoginLoading"
                  :disabled="oneClickUpdateForm.password !== oneClickUpdateForm.passwordConfirm || !oneClickUpdateForm.password">一键修改密码</el-button>
              </div>
            </el-form-item>
            <el-form-item v-if="loginTips?.msg">
              <el-alert :title="loginTips?.msg" :type="loginTips?.type" show-icon :closable="false" />
            </el-form-item>
          </el-form>
        </div>
      </el-tab-pane>
    </el-tabs>
  </el-dialog>
  <AliCaptcha ref="aliCaptchaRef"></AliCaptcha>
  <Contract ref="contractRef"></Contract>
</template>

<script setup lang="ts">
import {
  ref,
  reactive,
  watch,
  onUnmounted,
  getCurrentInstance,
  onMounted,
} from 'vue'
import { Iphone, Lock, User } from '@element-plus/icons-vue'
import { useUserInfoStore } from '@/stores/userInfo'
import { ElMessage } from 'element-plus'
import Contract from '@/components/Contract/index.vue'
import AliCaptcha from '@/components/AliCaptcha/index.vue'
import { decodeId } from '../Liuyao/util'
import { PhoneNumberServer } from 'aliyun_numberauthsdk_web';
import mixpanelService from '@/plugin/mixpanel'
import { EventName, LoginModalPosition } from '@/constants'
const currentInstance = getCurrentInstance()
const { $api } = currentInstance!.appContext.config.globalProperties
const aliCaptchaRef = ref()
const contractRef = ref()
const oneClickUpdateRef = ref(null)

// 本机号码修改表单，必须在顶部声明，保证模板可用
const oneClickUpdateForm = reactive({
  password: '',
  passwordConfirm: ''
})

// 用户信息
const { setUserInfo } = useUserInfoStore()
// 用户信息
const userInfoStore: any = useUserInfoStore()
// 弹框状态与事件
const props = defineProps({
  showModal: Boolean,
  taskId: String,
})
const localShowModal = ref(props.showModal)
const localTaskId = ref(props.taskId)
const activeName = ref('account')
const contractValue = ref(false)
const emit = defineEmits(['update:showModal', 'loginSuccess'])
const handleClickTab = (tab: { paneName: string }) => {
  mixpanelService.track(EventName.ClickLoginModalButton, {
    position: `${LoginModalPosition.Tab}-${tab.paneName}`,
  })
  activeName.value = tab.paneName
  loginTips.value = {
    msg: '',
    type: '',
  }
}
const handleClickRegister = () => {
  mixpanelService.track(EventName.ClickLoginModalButton, {
    position: LoginModalPosition.Register,
  })
  handleClick({ name: 'phone' });
}
const handleClick = (tab: { name: string }) => {
  activeName.value = tab.name
  loginTips.value = {
    msg: '',
    type: '',
  }

  // 每次点击一键登录标签页时都检测网络（包括重复点击）
  if (tab.name === 'oneClick') {
    checkNetworkType()
  }
}
watch(
  () => props.showModal,
  (newVal) => {
    localShowModal.value = newVal
  }
)
watch(
  () => props.taskId,
  (newVal) => {
    localTaskId.value = newVal
  }
)

// 弹窗曝光埋点
watch(
  localShowModal,
  (visible) => {
    if (visible) {
      mixpanelService.track(EventName.ShowLoginModal)
    }
  }
)
const btnBlur = (evt: {
  target: {
    blur(): Function
    nodeName: string
    parentNode: any
  }
}) => {
  let target = evt.target
  if (target.nodeName == 'SPAN') {
    target = evt.target.parentNode
  }
  target.blur()
}
const getQueryParam = (param: any) => {
  const regex = new RegExp('[?&]' + param + '(=([^&#]*)|&|#|$)')
  const results = regex.exec(window.location.href)
  if (!results) return null
  if (!results[2]) return ''
  return decodeURIComponent(results[2].replace(/\+/g, ' '))
}
// 60s 倒计时
const countDown = ref(60)
const isCountingDown = ref(false)
const nickName = ref('')
const inviteCode = ref()
let timer: any = null
const startTimer = () => {
  if (timer) {
    clearInterval(timer)
  }
  isCountingDown.value = true
  timer = setInterval(() => {
    countDown.value--
    if (countDown.value <= 0) {
      clearInterval(timer)
      timer = null
      countDown.value = 60
      isCountingDown.value = false
    }
  }, 1000)
}
const getNickName = () => {
  $api({
    url: import.meta.env.VITE_BASE_URL_API + '/userInfo/getNickNameByUId',
    headers: {
      'x-wx-openid': 'web',
    },
    method: 'GET',
    params: { userId: inviteCode.value },
  }).then((res: any) => {
    if (res.data.code == 0) {
      nickName.value = res?.data?.data
    } else {
      ElMessage.error(res?.data?.data)
    }
  })
}

// 处理邀请码输入
const handleInviteCodeInput = (value: string) => {
  if (value && value.trim()) {
    // 如果输入了邀请码，更新inviteCode并获取邀请人信息
    inviteCode.value = decodeId(value.trim())
    // 如果inviteCode.value值为空，返回
    if (!inviteCode.value) {
      return
    }
    getNickName()
  } else {
    // 如果清空了邀请码，恢复原来的邀请码（如果有的话）
    const inviteId = getQueryParam('ref')
    if (inviteId) {
      const decodedInviteId = decodeId(inviteId)
      if (decodedInviteId) {
        inviteCode.value = decodedInviteId
        getNickName()
      } else {
        inviteCode.value = ''
        nickName.value = ''
      }
    } else {
      inviteCode.value = ''
      nickName.value = ''
    }
  }
}
onMounted(() => {
  const inviteId = getQueryParam('ref')
  if (inviteId) {
    const decodedInviteId = decodeId(inviteId)
    if (decodedInviteId) {
      inviteCode.value = decodedInviteId
      getNickName()
    }
  }
  loadPhoneNumberServer()
})
// 清除定时器
onUnmounted(() => {
  if (timer) {
    clearInterval(timer)
  }
  if (loginTimer) {
    clearTimeout(loginTimer)
  }
})

// 登录表单
const loginRef = ref(null)
const loginLoading = ref(false)
const isNewUser = ref(false)
const loginForm = reactive({
  phoneNumber: '',
  phoneCodeValue: '',
  password: '',
  inviteCodeInput: '',
})

const rules = {
  phoneNumber: [
    { required: true, message: '请输入手机号码', trigger: 'blur' },
    {
      pattern: /^1[3-9]\d{9}$/,
      message: '请输入正确的手机号码',
      trigger: 'blur',
    },
  ],
  phoneCodeValue: [
    { required: true, message: '请输入验证码', trigger: 'blur' },
    { min: 4, max: 6, message: '', trigger: 'blur' },
  ],
  password: [
    { required: true, message: '请输入密码', trigger: 'blur' },
    { min: 6, message: '最少6个字符', trigger: 'blur' },
    { max: 18, message: '最多18个字符', trigger: 'blur' },
  ],
  passwordConfirm: [
    { required: true, message: '请再次输入密码', trigger: 'blur' },
    { min: 6, message: '最少6个字符', trigger: 'blur' },
    { max: 18, message: '最多18个字符', trigger: 'blur' },
  ],
}

const sendVerificationCode = async () => {
  if (!forgetPasswordVisible.value) {
    if (!loginForm.phoneNumber) {
      ElMessage.error('请输入手机号码')
      return
    }
    if (!/^1[3-9]\d{9}$/.test(loginForm.phoneNumber)) {
      ElMessage.error('请输入正确的手机号码')
      return
    }
  } else {
    if (!updatePasswordForm.phoneNumber) {
      ElMessage.error('请输入手机号码')
      return
    }
    if (!/^1[3-9]\d{9}$/.test(updatePasswordForm.phoneNumber)) {
      ElMessage.error('请输入正确的手机号码')
      return
    }
  }
  let aliCaptcha = await aliCaptchaRef.value.openAliCaptcha()
  // console.log(aliCaptcha_token)
  if (!aliCaptcha) {
    return
  }

  // 60s 倒计时
  startTimer()

  // 调用发送验证码的API
  const query = {
    phoneNumber: loginForm?.phoneNumber,
    lotNumber: aliCaptcha.lot_number,
    passToken: aliCaptcha.pass_token,
    captchaOutput: aliCaptcha.captcha_output,
    genTime: aliCaptcha.gen_time,
  }
  const updatePasswordQuery = {
    phoneNumber: updatePasswordForm?.phoneNumber,
    lotNumber: aliCaptcha.lot_number,
    passToken: aliCaptcha.pass_token,
    captchaOutput: aliCaptcha.captcha_output,
    genTime: aliCaptcha.gen_time,
  }

  $api({
    url: import.meta.env.VITE_BASE_URL_API + '/userInfo/sendSmsVerifyCode',
    withCredentials: false,
    method: 'post',
    data: !forgetPasswordVisible.value ? query : updatePasswordQuery,
  })
    .then((sendSmsVerifyCodeRes: any) => {
      if (sendSmsVerifyCodeRes?.data?.code === 0) {
        openUpdatePasswordTips('验证码已发送', 'success')
        updatePasswordLoading.value = false
      } else {
        updatePasswordLoading.value = false
        if (sendSmsVerifyCodeRes?.data?.errorMsg) {
          openUpdatePasswordTips(sendSmsVerifyCodeRes?.data?.errorMsg, 'error')
        } else {
          openUpdatePasswordTips(
            processCode(sendSmsVerifyCodeRes?.data?.code),
            'error'
          )
        }
      }
    })
    .catch((e: any) => {
      ElMessage.error('验证码发送失败')
    })
}

// 登录提示
let loginTimer: any = null
const loginTips = ref({
  msg: '',
  type: '',
})
const processCode = (code: any) => {
  switch (code) {
    case 1:
      return '登录失敗'
    case 2012:
      return '服务异常'
    case 204:
      return '未登陆'
    case 208:
      return '登录失敗'
    case 209:
      return '没有权限'
  }
}
const openTips = (msg: any, type: any) => {
  loginTips.value = { msg, type }
}

// 如果有taskId，则保留当前记录
const saveRecord = (loginStatusResult: any, token?: string) => {
  $api({
    url: import.meta.env.VITE_BASE_URL_API + '/question/saveRecord',
    method: 'GET',
    headers: {
      'tianji-token': loginStatusResult?.data?.data?.['tianji-token'] || token,
    },
    params: { taskId: localTaskId.value },
  })
}

const handleClickLoginButton = (evt: any, openTipsEvent: any) => {
  mixpanelService.track(EventName.ClickLoginModalButton, {
    position: LoginModalPosition.Login
  })
  submitForm(evt, openTipsEvent)
}

const handleClickLoginAndRegisterButton = (evt: any, openTipsEvent: any) => {
  mixpanelService.track(EventName.ClickLoginModalButton, {
    position: LoginModalPosition.LoginAndRegister
  })
  submitForm(evt, openTipsEvent)
}

// 登录接口调用
const submitForm = async (evt: any, openTipsEvent: any) => {
  btnBlur(evt)
  let reason = '';
  if (!loginForm.phoneNumber) {
    reason = '请输入手机号码'
  } else if (!/^1[3-9]\d{9}$/.test(loginForm.phoneNumber)) {
    reason = '请输入正确的手机号码'
  } else if (activeName?.value === 'account') {
    if (!loginForm.password) {
      reason = '请输入密码'
    } else if (loginForm?.password?.length < 6) {
      reason = '最少6个字符'
    } else if (loginForm?.password?.length > 18) {
      reason = '最多18个字符'
    }
  } else if (!loginForm.phoneCodeValue) {
    reason = '请输入验证码'
  } else if (!contractValue.value) {
    reason = '请同意协议'
  }

  if (reason) {
    ElMessage.error(reason)
    mixpanelService.track(EventName.SubmitLoginForm, {
      reason
    })
    return
  }

  // 调用登录的API
  const phoneBody = {
    account: loginForm?.phoneNumber,
    verifyCode: loginForm?.phoneCodeValue,
    type: 'phone',
    expireDays: 999,
    inviterUId: inviteCode.value,
  }
  const accountBody = {
    account: loginForm?.phoneNumber,
    password: loginForm?.password,
    type: 'phone',
    expireDays: 999,
    inviterUId: inviteCode.value,
  }
  loginLoading.value = true
  const loginStatusResult = await $api({
    url: import.meta.env.VITE_BASE_URL_API + '/userInfo/loginWeb',
    method: 'POST',
    data: activeName?.value === 'account' ? accountBody : phoneBody,
  })

  if (loginStatusResult?.data?.code === 0) {
    // 校验是否为新用户
    const isNew = loginStatusResult?.data?.data?.isNew || false

    if (isNew) {
      isNewUser.value = isNew
      initPasswordVisible.value = true
      initPasswordForm.phoneNumber = loginForm?.phoneNumber

      setUserInfo({
        ...{ ...phoneBody, ...accountBody },
        token: loginStatusResult?.data?.data?.['tianji-token'],
        deviceId: userInfoStore?.userInfo?.deviceId,
      })

      return
    }

    const userInfoResult = await $api({
      url: import.meta.env.VITE_BASE_URL_API + '/userInfo/getUserInfo',
      method: 'GET',
      headers: {
        'tianji-token': loginStatusResult?.data?.data?.['tianji-token'],
      },
    })

    const userInfo = {
      ...(userInfoResult?.data?.data || { ...phoneBody, ...accountBody }),
      token: loginStatusResult?.data?.data?.['tianji-token'],
      deviceId: userInfoStore?.userInfo?.deviceId,
    }

    setUserInfo(userInfo)

    // Mixpanel identify 用户（登录成功）
    const userId = userInfo.id || userInfo.phone || loginForm.phoneNumber
    if (userId) {
      const userProperties = {
        name: userInfo.name,
        phone: userInfo.phone,
        email: userInfo.email,
        login_method: activeName.value === 'account' ? 'password' : 'sms',
        // 可以根据需要添加更多属性
      }
      mixpanelService.identify(userId, userProperties)
    }

    openTips('登录成功', 'success')
    loginLoading.value = false

    // 发出登录成功事件
    emit('loginSuccess')

    loginTimer = setTimeout(() => {
      clearTimeout(loginTimer)
      closeModal()
    }, 800)

    // 如果已有任务，则登录后保存
    if (localTaskId.value) {
      saveRecord(loginStatusResult)
    }

    mixpanelService.track(EventName.SubmitLoginForm)
  } else {
    loginLoading.value = false
    let reason = '';
    if (loginStatusResult?.data?.errorMsg) {
      reason = loginStatusResult?.data?.errorMsg
      openTips(reason, 'error')
    } else {
      reason = processCode(loginStatusResult?.data?.code) ?? ''
      openTips(reason, 'error')
    }
    mixpanelService.track(EventName.SubmitLoginForm, {
      reason
    })
  }
}

const closeModal = () => {
  clearTimeout(loginTimer)
  // 登录相关
  loginForm.phoneCodeValue = ''
  loginForm.phoneNumber = ''
  loginForm.password = ''
  loginForm.inviteCodeInput = ''

  // 用户注册相关
  initPasswordForm.passwordConfirm = ''
  initPasswordForm.phoneNumber = ''
  initPasswordForm.password = ''
  initPasswordVisible.value = false

  // 修改密码相关
  updatePasswordForm.phoneCodeValue = ''
  updatePasswordForm.phoneNumber = ''
  updatePasswordForm.password = ''
  forgetPasswordVisible.value = false

  contractValue.value = false
  activeName.value = 'account'
  activeUpdatePassword.value = 'verifyCode'
  emit('update:showModal', false)

  loginTips.value = {
    msg: '',
    type: '',
  }
  updatePasswordTips.value = {
    msg: '',
    type: '',
  }
  initPasswordTips.value = {
    msg: '',
    type: '',
  }
}
const scanContract = (status: number) => {
  contractRef.value.openDrawer(status)
}

// 新用户注册
const initPasswordRef = ref(null)
const initPasswordVisible = ref(false)
const initPasswordForm = reactive({
  phoneNumber: '',
  password: '',
  passwordConfirm: '',
})
const initPasswordLoading = ref(false)
const initPassword = (evt: any) => {
  initPasswordVisible.value = true
  // initPasswordTips.value.msg="";
  // initPasswordTips.value.type="";
}
const initPasswordTips = ref({
  msg: '',
  type: '',
})
const openInitPasswordTips = (msg: any, type: any) => {
  initPasswordTips.value = {
    msg,
    type,
  }
}
const handleInitPassword = async (evt: any, openTipsEvent: any) => {
  if (!initPasswordForm.phoneNumber) {
    ElMessage.error('请输入手机号码')
    return
  }
  if (!/^1[3-9]\d{9}$/.test(initPasswordForm.phoneNumber)) {
    ElMessage.error('请输入正确的手机号码')
    return
  }
  if (!initPasswordForm.password || !initPasswordForm.passwordConfirm) {
    ElMessage.error('请输入新密码')
    return
  }
  if (
    initPasswordForm?.password?.length < 6 ||
    initPasswordForm?.passwordConfirm?.length < 6
  ) {
    ElMessage.error('最少6个字符')
    return
  }
  if (
    initPasswordForm?.password?.length > 18 ||
    initPasswordForm?.passwordConfirm?.length > 18
  ) {
    ElMessage.error('最多18个字符')
    return
  }

  if (initPasswordForm?.password !== initPasswordForm?.passwordConfirm) {
    ElMessage.error('密码不一致')
    return
  }

  // 调用初始化密码的API
  initPasswordLoading.value = true
  const initPasswordResult = await $api({
    url: import.meta.env.VITE_BASE_URL_API + '/userInfo/initPassword  ',
    method: 'POST',
    headers: {
      'tianji-token': userInfoStore?.userInfo?.token,
      'tianji-deviceId': userInfoStore?.userInfo?.deviceId,
    },
    data: {
      account: initPasswordForm?.phoneNumber,
      newPassword: initPasswordForm?.password,
    },
  })

  if (initPasswordResult?.data?.code === 0) {
    const userInfoResult = await $api({
      url: import.meta.env.VITE_BASE_URL_API + '/userInfo/getUserInfo',
      method: 'GET',
      headers: {
        'tianji-token': userInfoStore?.userInfo?.token,
      },
    })

    const newUserInfo = {
      ...userInfoResult?.data?.data,
      token: userInfoStore?.userInfo?.token,
      deviceId: userInfoStore?.userInfo?.deviceId,
    }

    setUserInfo(newUserInfo)

    // Mixpanel identify 用户（新用户注册成功）
    const userId = newUserInfo.id || newUserInfo.phone || initPasswordForm.phoneNumber
    if (userId) {
      const userProperties = {
        name: newUserInfo.name,
        phone: newUserInfo.phone,
        email: newUserInfo.email,
        is_new_user: true,
        registration_method: 'phone_verification',
        // 可以根据需要添加更多属性
      }
      mixpanelService.identify(userId, userProperties)
    }

    openInitPasswordTips('注册成功', 'success')
    initPasswordLoading.value = false

    // 发出登录成功事件
    emit('loginSuccess')

    loginTimer = setTimeout(() => {
      clearTimeout(loginTimer)
      closeModal()
    }, 800)

    // 如果已有任务，则登录后保存
    if (localTaskId.value) {
      saveRecord(null, userInfoStore?.userInfo?.token)
    }
  } else {
    initPasswordLoading.value = false
    if (initPasswordResult?.data?.errorMsg) {
      openInitPasswordTips(initPasswordResult?.data?.errorMsg, 'error')
    } else {
      openInitPasswordTips(processCode(initPasswordResult?.data?.code), 'error')
    }
  }
}

// 忘记密码
const updatePasswordRef = ref(null)
const forgetPasswordVisible = ref(false)
const updatePasswordForm = reactive({
  phoneNumber: '',
  phoneCodeValue: '',
  password: '',
})
const updatePasswordLoading = ref(false)
const forgetPassword = (evt: any) => {
  forgetPasswordVisible.value = true
  // updatePasswordTips.value.msg="";
  // updatePasswordTips.value.type="";
}
const activeUpdatePassword = ref('verifyCode')
const handleUpdatePasswordClick = (tab: { name: string }) => {
  activeUpdatePassword.value = tab.name
}
const updatePasswordTips = ref({
  msg: '',
  type: '',
})
const openUpdatePasswordTips = (msg: any, type: any) => {
  updatePasswordTips.value = {
    msg,
    type,
  }
}
const updatePassword = async (evt: any, openTipsEvent: any) => {
  if (!updatePasswordForm.phoneNumber) {
    ElMessage.error('请输入手机号码')
    return
  }
  if (!/^1[3-9]\d{9}$/.test(updatePasswordForm.phoneNumber)) {
    ElMessage.error('请输入正确的手机号码')
    return
  }
  if (!updatePasswordForm.phoneCodeValue) {
    ElMessage.error('请输入验证码')
    return
  }
  if (!updatePasswordForm.password) {
    ElMessage.error('请输入新密码')
    return
  }
  if (updatePasswordForm?.password?.length < 6) {
    ElMessage.error('最少6个字符')
    return
  }
  if (updatePasswordForm?.password?.length > 18) {
    ElMessage.error('最多18个字符')
    return
  }

  // 调用修改的API
  const phoneBody = {
    account: updatePasswordForm?.phoneNumber,
    verifyCode: updatePasswordForm?.phoneCodeValue,
    type: 'phone',
    newPassword: updatePasswordForm?.password,
  }
  updatePasswordLoading.value = true
  const updatePasswordStatusResult = await $api({
    url: import.meta.env.VITE_BASE_URL_API + '/userInfo/changePassword',
    method: 'POST',
    data: phoneBody,
  })

  if (updatePasswordStatusResult?.data?.code === 0) {
    openUpdatePasswordTips('修改密码成功', 'success')
    updatePasswordLoading.value = false
  } else {
    updatePasswordLoading.value = false
    if (updatePasswordStatusResult?.data?.errorMsg) {
      openUpdatePasswordTips(
        updatePasswordStatusResult?.data?.errorMsg,
        'error'
      )
    } else {
      openUpdatePasswordTips(
        processCode(updatePasswordStatusResult?.data?.code),
        'error'
      )
    }
  }
}

// 创建PhoneNumberServer实例
const phoneNumberServerRef = ref<any | null>(null)

// 动态导入PhoneNumberServer
const loadPhoneNumberServer = async () => {
  if (!phoneNumberServerRef.value) {
    try {
      const { PhoneNumberServer } = await import('aliyun_numberauthsdk_web')
      phoneNumberServerRef.value = new PhoneNumberServer()
    } catch (error) {
      console.error('Failed to load PhoneNumberServer:', error)
      throw new Error('Failed to load PhoneNumberServer')
    }
  }
  return phoneNumberServerRef.value
}

// 创建PhoneNumberServer实例
// const phoneNumberServer = new PhoneNumberServer() as any

// 一键登录相关状态
const oneClickLoginLoading = ref(false)

// 网络检测相关状态
const isCellularNetwork = ref(false)
const retryLoading = ref(false)

// 检测网络类型
const checkNetworkType = () => {
  try {
    const netType = phoneNumberServerRef.value?.getConnection()
    console.log('网络类型:', netType)
    ElMessage.info('您的网络类型为：' + netType);
    isCellularNetwork.value = netType !== 'wifi'
    return netType !== 'wifi'
    //return netType === 'cellular'
  } catch (error) {
    console.error('网络检测失败:', error)
    isCellularNetwork.value = false
    return false
  }
}

const handleClickLoginRetryNetwork = () => {
  mixpanelService.track(EventName.ClickLoginModalButton, {
    position: LoginModalPosition.RetryOneClickLoginNetwork
  })
  retryNetworkCheck()
}
const handleClickChangePasswordRetryNetwork = () => {
  retryNetworkCheck()
}
// 重试网络检测
const retryNetworkCheck = async () => {
  retryLoading.value = true
  try {
    // 稍微延迟一下，让用户感觉到正在检测
    //await new Promise(resolve => setTimeout(resolve, 00))
    const isConnected = checkNetworkType()
    if (isConnected) {
      ElMessage.success('网络检测通过')
    } else {
      ElMessage.warning('仍未检测到移动网络，请确认已关闭WiFi和vpn。')
    }
  } finally {
    retryLoading.value = false
  }
}

// 一键登录处理方法
const handleOneClickLogin = async () => {
  mixpanelService.track(EventName.ClickLoginModalButton, {
    position: LoginModalPosition.OneClickLogin
  })

  try {
    // 首先检查是否同意协议
    if (!contractValue.value) {
      ElMessage.error('请同意用户协议、隐私政策和付费协议')
      return
    }

    oneClickLoginLoading.value = true

    // 检测协议
    const protocol = window.location.protocol
    // 转换协议格式：去掉冒号，只保留 http 或 https
    const httpType = protocol.replace(':', '')

    // 获取网络类型
    const netType = phoneNumberServerRef.value?.getConnection()

    // 检查网络类型
    if (netType === 'wifi') {
      ElMessage.error('请关闭WiFi和vpn，打开移动数据后重试')
      return
    }

    // 调用后端接口获取授权token

    const authTokenResult = await $api({
      url: import.meta.env.VITE_BASE_URL_API + '/userInfo/getAuthToken',
      method: 'GET',
      params: {
        httpType: httpType
      }
    })

    if (authTokenResult?.data?.code === 0) {
      const { accessToken, jwtToken } = authTokenResult.data.data

      console.log('获取到的tokens:', { accessToken, jwtToken })

      // 调用SDK进行鉴权
      phoneNumberServerRef.value?.checkLoginAvailable({
        accessToken: accessToken,
        jwtToken: jwtToken,
        success: function (res: any) {
          console.log('鉴权结果:', res);
          if (res.code === 600000) {
            console.log("鉴权成功", res);

            // 鉴权成功后调用getLoginToken方法
            getLoginToken()
          } else {
            console.log("鉴权失败", res);
            ElMessage.error('登录失败，请关闭WiFi并重新打开网页后重试')
          }
        },
        error: function (res: any) {
          console.log("鉴权失败", res);
          ElMessage.error('登录失败，请关闭WiFi并重新打开网页后重试')
        }
      })

    } else {
      ElMessage.error('登录失败，请关闭WiFi并重新打开网页后重试')
    }

  } catch (error) {
    console.error('一键登录失败:', error)
    ElMessage.error('一键登录失败，请关闭WiFi并重新打开网页后重试')
  } finally {
    oneClickLoginLoading.value = false
  }
}


// 一键登录处理方法
const handleOneClickChangePassword = async () => {
  try {

    oneClickLoginLoading.value = true

    // 检测协议
    const protocol = window.location.protocol
    // 转换协议格式：去掉冒号，只保留 http 或 https
    const httpType = protocol.replace(':', '')

    // 获取网络类型
    const netType = phoneNumberServerRef.value?.getConnection()

    // 检查网络类型
    if (netType === 'wifi') {
      ElMessage.error('请关闭WiFi和vpn，打开移动数据后重试')
      return
    }

    // 调用后端接口获取授权token

    const authTokenResult = await $api({
      url: import.meta.env.VITE_BASE_URL_API + '/userInfo/getAuthToken',
      method: 'GET',
      params: {
        httpType: httpType
      }
    })

    if (authTokenResult?.data?.code === 0) {
      const { accessToken, jwtToken } = authTokenResult.data.data

      // 调用SDK进行鉴权
      phoneNumberServerRef.value?.checkLoginAvailable({
        accessToken: accessToken,
        jwtToken: jwtToken,
        success: function (res: any) {
          console.log('鉴权结果:', res);
          if (res.code === 600000) {
            console.log("鉴权成功", res);

            // 鉴权成功后调用getChangePasswordToken方法
            getChangePasswordToken()
          } else {
            console.log("鉴权失败", res);
            ElMessage.error('修改密码失败，请关闭WiFi并重新打开网页后重试')
          }
        },
        error: function (res: any) {
          console.log("鉴权失败", res);
          ElMessage.error('修改密码失败，请关闭WiFi并重新打开网页后重试')
        }
      })

    } else {
      ElMessage.error('修改密码失败，请关闭WiFi并重新打开网页后重试')
    }

  } catch (error) {
    console.error('修改密码失败:', error)
    ElMessage.error('修改密码失败，请关闭WiFi并重新打开网页后重试')
  } finally {
    oneClickLoginLoading.value = false
  }
}

// 调用getLoginToken方法
const getChangePasswordToken = () => {
  phoneNumberServerRef.value?.getLoginToken({
    authPageOption: {
      navText: "萤火海海修改密码",
      subtitle: "请补全您的手机号",
      isHideLogo: true,
      logoImg: "",
      btnText: "立即修改",
      agreeSymbol: "、",

      showCustomView: false,
      privacyBefore: "我已阅读并同意",
      privacyEnd: "",
      vendorPrivacyPrefix: "《",
      vendorPrivacySuffix: "》",
      privacyVenderIndex: 2,
      isDialog: true, // 弹窗样式
      manualClose: false, // 手动关闭弹窗
      isPrePageType: false,
      isShowProtocolDesc: true,
    },
    success: (res: any) => {
      console.log('getLoginToken成功:', res);
      if (res.code === 600000) {
        console.log("获取spToken成功", res);
        //ElMessage.success('正在验证手机号...')
        // 拿到spToken后发送到后端验证获取手机号
        changePasswordWithToken(res.spToken)

      } else {
        console.log("获取spToken失败", res);
        ElMessage.error('获取修改密码凭证失败，请关闭WiFi并重新打开网页后重试')
      }
    },
    error: (res: any) => {
      console.log("getLoginToken失败", res);
      ElMessage.error('获取修改密码凭证失败，请关闭WiFi并重新打开网页后重试')
    },
    watch: function (status: number, data: any) {
      console.log('授权页状态:', status, data);
      // 当status为2时整个流程结束
      if (status === 2) {
        oneClickLoginLoading.value = false
      }
    }
  })
}

// 使用spToken修改密码
const changePasswordWithToken = async (spToken: string) => {
  try {
    ElMessage.success('正在验证手机号...')

    // 构建请求参数
    const params: any = {
      spToken: spToken,
      password: oneClickUpdateForm.password
    }

    const loginResult = await $api({
      url: import.meta.env.VITE_BASE_URL_API + '/userInfo/changePasswordByOneClick',
      method: 'GET',
      params: params
    })

    if (loginResult?.data?.code === 0) {
      // 检查是否为新用户
      const isNew = loginResult?.data?.data?.isNew || false
      const phone = loginResult?.data?.data?.phone || ''

      if (isNew) {
        // 新用户需要设置密码
        isNewUser.value = isNew
        initPasswordVisible.value = true
        // 将返回的手机号填入设置密码表单
        initPasswordForm.phoneNumber = phone

        setUserInfo({
          token: loginResult?.data?.data?.['tianji-token'],
          deviceId: userInfoStore?.userInfo?.deviceId,
        })

        mixpanelService.track(EventName.SubmitLoginForm);
        ElMessage.success('新用户注册成功，请设置初始密码')
        return
      }

      // 获取用户信息
      const userInfoResult = await $api({
        url: import.meta.env.VITE_BASE_URL_API + '/userInfo/getUserInfo',
        method: 'GET',
        headers: {
          'tianji-token': loginResult?.data?.data?.['tianji-token'],
        },
      })

      setUserInfo({
        ...(userInfoResult?.data?.data || {}),
        token: loginResult?.data?.data?.['tianji-token'],
        deviceId: userInfoStore?.userInfo?.deviceId,
      })

      ElMessage.success('修改密码成功')

      // 发出登录成功事件
      emit('loginSuccess')

      // 延迟关闭弹窗
      loginTimer = setTimeout(() => {
        clearTimeout(loginTimer)
        // 手动关闭授权页
        try {
          phoneNumberServerRef.value?.closeLoginPage()
        } catch (error) {
          console.log('关闭授权页失败:', error)
        }
        closeModal()
      }, 800)

      // 如果已有任务，则登录后保存
      if (localTaskId.value) {
        saveRecord(loginResult)
      }

    } else {
      ElMessage.error(loginResult?.data?.errorMsg + '，请检查手机号' || '修改密码失败，请检查手机号')
    }
  } catch (error) {
    console.error('一键登录验证失败:', error)
    ElMessage.error('修改密码验证失败，请确保号码正确并重新打开网页后重试')
  } finally {
    oneClickLoginLoading.value = false
  }
}

// 一键登录标签页点击事件
const handleOneClickTabClick = () => {
  // 每次点击一键登录标签页都重新检测网络
  checkNetworkType()
}

// 调用getLoginToken方法
const getLoginToken = () => {
  phoneNumberServerRef.value?.getLoginToken({
    authPageOption: {
      navText: "萤火海海一键登录",
      subtitle: "请补全您的手机号",
      isHideLogo: true,
      logoImg: "",
      btnText: "立即登录",
      agreeSymbol: "、",

      showCustomView: false,
      privacyBefore: "我已阅读并同意",
      privacyEnd: "",
      vendorPrivacyPrefix: "《",
      vendorPrivacySuffix: "》",
      privacyVenderIndex: 2,
      isDialog: true, // 弹窗样式
      manualClose: false, // 手动关闭弹窗
      isPrePageType: false,
      isShowProtocolDesc: true,
    },
    success: (res: any) => {
      console.log('getLoginToken成功:', res);
      if (res.code === 600000) {
        console.log("获取spToken成功", res);
        //ElMessage.success('正在验证手机号...')
        // 拿到spToken后发送到后端验证获取手机号
        getPhoneWithToken(res.spToken)
      } else {
        console.log("获取spToken失败", res);
        ElMessage.error('获取凭证失败，请关闭WiFi并重新打开网页后重试')
      }
    },
    error: (res: any) => {
      console.log("getLoginToken失败", res);
      ElMessage.error('获取凭证失败，请关闭WiFi和vpn并重新打开网页后重试')
    },
    watch: function (status: number, data: any) {
      console.log('授权页状态:', status, data);
      // 当status为2时整个流程结束
      if (status === 2) {
        oneClickLoginLoading.value = false
      }
    }
  })
}

const isWeChat = () => {
  const ua = window.navigator.userAgent.toLowerCase()
  if (/micromessenger/i.test(ua)) {
    return false   // 微信浏览器 暂时不区分微信浏览器  如果需要区分则改为true
  } else {
    return false
  }
}

// 使用spToken获取手机号
const getPhoneWithToken = async (spToken: string) => {
  try {
    ElMessage.success('正在验证手机号...')

    // 构建请求参数
    const params: any = {
      spToken: spToken
    }

    // 如果有邀请码则添加到参数中（优先使用输入的邀请码，其次使用URL中的邀请码）
    const finalInviteCode = loginForm.inviteCodeInput || inviteCode.value
    if (finalInviteCode) {
      params.inviteId = finalInviteCode
    }

    const loginResult = await $api({
      url: import.meta.env.VITE_BASE_URL_API + '/userInfo/loginByOneClick',
      method: 'GET',
      params: params
    })

    if (loginResult?.data?.code === 0) {
      // 检查是否为新用户
      const isNew = loginResult?.data?.data?.isNew || false
      const phone = loginResult?.data?.data?.phone || ''

      if (isNew) {
        // 新用户需要设置密码
        isNewUser.value = isNew
        initPasswordVisible.value = true
        // 将返回的手机号填入设置密码表单
        initPasswordForm.phoneNumber = phone

        setUserInfo({
          token: loginResult?.data?.data?.['tianji-token'],
          deviceId: userInfoStore?.userInfo?.deviceId,
        })

        ElMessage.success('新用户注册成功，请设置初始密码')
        return
      }

      // 获取用户信息
      const userInfoResult = await $api({
        url: import.meta.env.VITE_BASE_URL_API + '/userInfo/getUserInfo',
        method: 'GET',
        headers: {
          'tianji-token': loginResult?.data?.data?.['tianji-token'],
        },
      })

      setUserInfo({
        ...(userInfoResult?.data?.data || {}),
        token: loginResult?.data?.data?.['tianji-token'],
        deviceId: userInfoStore?.userInfo?.deviceId,
      })

      ElMessage.success('一键登录成功')

      // 发出登录成功事件
      emit('loginSuccess')

      // 延迟关闭弹窗
      loginTimer = setTimeout(() => {
        clearTimeout(loginTimer)
        // 手动关闭授权页
        try {
          phoneNumberServerRef.value?.closeLoginPage()
        } catch (error) {
          console.log('关闭授权页失败:', error)
        }
        closeModal()
      }, 800)

      // 如果已有任务，则登录后保存
      if (localTaskId.value) {
        saveRecord(loginResult)
      }

    } else {
      ElMessage.error(loginResult?.data?.errorMsg + '，请检查手机号' || '一键登录失败，请检查手机号')
    }
  } catch (error) {
    console.error('一键登录验证失败:', error)
    ElMessage.error('一键登录验证失败，请确保号码正确后重试或切换登录方式')
  } finally {
    oneClickLoginLoading.value = false
  }
}

const getCurrentUrl = () => {
  return window.location.href
}

const copyWebsiteLink = async () => {
  const url = getCurrentUrl()
  try {
    // 优先使用现代的 Clipboard API
    if (navigator.clipboard && window.isSecureContext) {
      await navigator.clipboard.writeText(url)
      ElMessage.success('链接已复制到剪贴板')
    } else {
      // 降级方案：使用传统的 document.execCommand
      const input = document.createElement('input')
      input.value = url
      document.body.appendChild(input)
      input.select()
      const successful = document.execCommand('copy')
      document.body.removeChild(input)

      if (successful) {
        ElMessage.success('链接已复制到剪贴板')
      } else {
        ElMessage.warning('复制失败，请手动选择链接进行复制')
      }
    }
  } catch (error) {
    console.error('复制链接失败:', error)
    ElMessage.warning('复制失败，请手动选择链接进行复制')
  }
}

const openInExternalBrowser = () => {
  // 在微信中无法直接跳转到外部浏览器，需要引导用户手动操作
  const url = getCurrentUrl()

  // 先复制链接到剪贴板
  copyWebsiteLink().then(() => {
    // 显示详细的操作指引
    ElMessage({
      message: '链接已复制！请点击右上角"⋯"按钮，选择"在浏览器中打开"',
      type: 'success',
      duration: 6000,
      showClose: true
    })
  }).catch(() => {
    // 如果复制失败，只显示操作指引
    ElMessage({
      message: '请点击右上角"⋯"按钮，选择"在浏览器中打开"',
      type: 'info',
      duration: 5000,
      showClose: true
    })
  })

  // 尝试通过多种方式唤起外部浏览器
  try {
    // 方法1：尝试使用 window.open
    const newWindow = window.open(url, '_blank', 'noopener,noreferrer')

    // 如果 window.open 被阻止，newWindow 会是 null
    if (!newWindow) {
      // 方法2：创建链接元素并点击
      const link = document.createElement('a')
      link.href = url
      link.target = '_blank'
      link.rel = 'noopener noreferrer'

      // 添加到文档中并触发点击
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
    }
  } catch (error) {
    console.log('无法直接跳转到外部浏览器:', error)
    // 这是预期的行为，微信会限制自动跳转
  }
}
</script>

<style lang="scss">
.login-dialog {
  // .modal-overlay {
  //   position: fixed;
  //   top: 0;
  //   left: 0;
  //   width: 100%;
  //   height: 100%;
  //   background: rgba(0, 0, 0, 0.5);
  //   display: flex;
  //   justify-content: center;
  //   align-items: center;
  // }

  .modal-content {
    background: white;
    padding: 20px;
    border-radius: 8px;
    text-align: center;
    width: 300px;
  }

  .close-modal {
    margin-top: 10px;
    background: transparent;
    border: none;
    color: blue;
    cursor: pointer;
  }

  .dialog-title {
    text-align: center;
  }

  .login-tabs {
    padding: 10px 5px;
    color: #6b778c;
    font-size: 16px;
    font-weight: 600;

    .el-tabs__header {
      margin: 0;
    }

    .el-tabs__nav-wrap {
      display: flex;
      justify-content: center;
    }

    .el-tabs__nav {
      display: flex;
      justify-content: space-between;
      width: 100%;
      max-width: 350px;
      margin: 0 auto;
      gap: 4px;

      .el-tabs__item {
        flex: 1;
        padding: 12px 15px !important;
        margin: 0 !important;
        text-align: center;
        position: relative;
        border-radius: 8px;
        transition: all 0.3s ease;
        background: #f8f9fa;
        color: #6b778c;
        font-size: 15px;
        font-weight: 500;
        border: 1px solid #e4e7ed;

        &:hover {
          background: #ecf5ff;
          color: #409eff;
          border-color: #b3d8ff;
        }

        &.is-active {
          background: #409eff;
          color: #ffffff;
          border-color: #409eff;
          font-weight: 600;
          transform: translateY(-1px);
          box-shadow: 0 2px 8px rgba(64, 158, 255, 0.3);
        }

        // 移除默认的下划线
        &::after {
          display: none;
        }

        // 移除分割线，现在用间距和边框代替
        &:not(:last-child)::after {
          display: none;
        }
      }
    }

    // 隐藏默认的下划线指示器
    .el-tabs__active-bar {
      display: none;
    }
  }

  .login-container {
    margin-top: 20px;
  }

  .login-content {
    display: flex;
    align-items: start;
    justify-content: center;
    padding-top: 10px;

    .inviteUser {
      font-size: 12px;

      .invite {
        color: red;
      }
    }

    .invite-code-item {
      margin-bottom: 16px;

      .invite-code-input {
        .el-input__wrapper {
          border-radius: 6px;
        }
      }
    }
  }

  .init-content {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;

    .init-content-title {
      margin-bottom: 24px;
      font-weight: 600;
    }
  }

  .verification-item .el-form-item__content {
    align-items: center;
    flex-wrap: nowrap;
  }


  .verification-code-btn {
    margin-left: 6px;
    // width: 88px;
  }

  .one-click-login-btn {
    margin-left: 6px;
    white-space: nowrap;
  }

  .login-btn {
    width: 100%;
    /* background-color: #333; */
  }

  .desc {
    font-size: 13px;
    color: #909399;
    text-align: center;
    margin: 8px 0 12px 0;
    padding: 6px 12px;
    background: #f5f7fa;
    border-radius: 4px;
    border-left: 3px solid #409eff;
    line-height: 1.4;
  }

  .checkbtn {
    margin-right: 4px;
  }

  .contract-text .el-form-item__content {
    font-size: 12px;
    line-height: normal;
  }

  .contract {
    color: #409eff;
    font-weight: 700;
  }

  .update-password-container .el-form-item__content {
    display: flex;
    width: 100%;
  }

  .update-password-container {
    margin-bottom: 0;

    .update-password-content {
      width: 100%;
      display: flex;
      justify-content: end;
      height: 36px;
    }

    .update-password {
      font-size: 0.74rem;
    }
  }

  .password-item {
    margin-bottom: 0px;
  }

  .update-password-tabs {
    padding: 10px;
    color: #6b778c;
    font-size: 32px;
    font-weight: 600;
  }

  .update-password-btn-container {
    margin-bottom: 12px;
  }

  .update-password-btn {
    width: 100%;
  }

  // 验证码提示样式
  .verification-tips {
    margin-bottom: 0;
    margin-top: 10px;

    .verification-tips-text {
      font-size: 12px;
      color: #f56c6c;
      line-height: 1.4;
    }
  }

  .one-click-login-desc {
    text-align: center;
    padding: 10px 20px 30px 20px;

    .one-click-login-main-btn {
      width: 100%;
      height: 44px;
      font-size: 16px;
      font-weight: 500;
      margin-bottom: 20px;
    }

    p {
      margin: 0 0 12px 0;
      font-size: 16px;
      color: #333;
      width: 100%;
      display: block;
    }

    .desc-text {
      margin: 0;
      font-size: 16px;
      color: #666;
      line-height: 1.5;
      width: 100%;
      display: block;
    }
  }

  .network-error-content {
    display: flex;
    align-items: start;
    justify-content: center;
  }

  .network-error-desc {
    text-align: center;
    padding: 10px 0px 10px 20px;

    .intro-text {
      margin: 0 0 20px 0;
      font-size: 16px;
      color: #333;
      font-weight: 500;
      line-height: 1.5;
      width: 100%;
      display: block;
    }

    .error-text {
      margin: 0;
      font-size: 18px;
      color: #f56c6c;
      font-weight: 600;
      line-height: 1.6;
      letter-spacing: 0.5px;
      width: 100%;
      display: block;
    }
  }

  .retry-btn {
    width: 100%;
    height: 44px;
    font-size: 16px;
    font-weight: 500;
  }

  .wechat-browser-tip {
    text-align: center;
    padding: 0px 20px 0px 20px;

    .wechat-tip-content {
      padding: 0px 20px 0px 20px;

      .error-text {
        margin: 0;
        font-size: 18px;
        color: #f56c6c;
        font-weight: 600;
        line-height: 1.6;
        letter-spacing: 0.5px;
        width: 100%;
        display: block;
      }

      .suggestion-text {
        margin: 0;
        font-size: 16px;
        color: #666;
        line-height: 1.5;
        width: 100%;
        display: block;
      }

      .website-link {
        margin-top: 5px;
        padding: 16px;
        background: #f8f9fa;
        border-radius: 8px;
        border: 1px solid #e4e7ed;

        .link-header {
          display: flex;
          justify-content: space-between;
          align-items: center;
          margin-bottom: 0px;

          .link-label {
            margin: 0;
            font-size: 14px;
            color: #333;
            font-weight: 500;
          }

          .copy-btn {
            align-self: flex-start;
            font-size: 12px;
            height: 28px;
            padding: 0 16px;
          }
        }

        .link-container {
          display: flex;
          flex-direction: column;
          gap: 10px;

          .link-text {
            font-size: 12px;
            color: #409eff;
            word-break: break-all;
            line-height: 1.4;
            padding: 8px 12px;
            background: #ffffff;
            border: 1px solid #dcdfe6;
            border-radius: 4px;
            user-select: all;
            cursor: text;
          }
        }
      }
    }
  }

  .switch-login-btn {
    width: 100%;
    height: 44px;
    font-size: 16px;
    font-weight: 500;
  }

  .browser-tip {
    text-align: center;
    padding: 0px 00px 0px 0px;
    width: 100%;

    .tip-text {
      margin: 0px 0;
      font-size: 13px;
      color: #909399;
      line-height: 1.4;
      width: 100%;
      display: block;

      &:first-child {
        margin-top: 0;
      }

      &:last-child {
        margin-bottom: 0;
      }
    }
  }
}
</style>